import loadable from '@loadable/component';
import { LoadableFunctionalComponent } from '../../../utils/index.ts';
import { ActionButtonLoader } from '../../../shared/index.ts';
import { ActionButtonViewProps } from './component/types.ts';

export const ActionButton = loadable(() => import('./component/index.tsx'), {
  resolveComponent: (components) => components.ActionButtonComponent,
  fallback: <ActionButtonLoader />,
}) as LoadableFunctionalComponent<ActionButtonViewProps>;
